import type { AxiosInstance, AxiosResponse, AxiosError } from 'axios'
import type { AxiosDataResponse, ApiResponse } from '../../../config/api-types'
import { COLLECTION_ORDER_ENDPOINTS } from '../../../config/endpoints'
import type { ICreateCollectionOrderClient } from '../data/data-sources/i-create-collection-order-client'
import type { CreateCollectionOrderRequest } from '../domain/models/create-collection-order'

export class CreateCollectionOrderService implements ICreateCollectionOrderClient {
  constructor(private readonly axios: AxiosInstance) {}

  async create(params: CreateCollectionOrderRequest): Promise<ApiResponse> {
    try {
      const result: AxiosResponse<AxiosDataResponse> = await this.axios.post(
        COLLECTION_ORDER_ENDPOINTS.create,
        params,
      )

      return {
        success: result.data.success,
        data: result.data.data,
        message: result.data.message,
        status: result.status,
      }
    } catch (error: any) {
      const axiosError = error as AxiosError<AxiosDataResponse>
      return {
        success: false,
        message: axiosError.response?.data?.message,
        status: axiosError.response?.status!,
      }
    }
  }
}
